var _circle, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClientFocus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "url(#paint0_linear_155_49)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.0618 20.3943C43.3021 21.6356 44.0172 23.3066 44.0591 25.0609C44.101 26.8152 43.4664 28.5184 42.2868 29.8176L29.9984 43.3343L17.7151 29.8176C17.0916 29.142 16.611 28.3475 16.3019 27.4818C15.9928 26.616 15.8617 25.6967 15.9164 24.779C15.9711 23.8614 16.2105 22.9642 16.6202 22.1413C17.03 21.3183 17.6016 20.5866 18.3009 19.9899C19.0003 19.3932 19.8128 18.9438 20.69 18.6686C21.5671 18.3934 22.4908 18.2982 23.4056 18.3885C24.3205 18.4789 25.2077 18.753 26.014 19.1945C26.8204 19.6359 27.5294 20.2356 28.0984 20.9576L30.0001 23.3326L31.9001 20.9576C32.5004 20.2081 33.252 19.5936 34.1058 19.1541C34.9595 18.7146 35.8964 18.46 36.8551 18.4068C37.8139 18.3536 38.7731 18.5032 39.6703 18.8456C40.5674 19.1881 41.3823 19.7157 42.0618 20.3943Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_155_49",
    x1: 30,
    y1: 0,
    x2: 30,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3896BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A4558"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientFocus);
export default __webpack_public_path__ + "static/media/ClientFocus.82531766f2181a8780da009e1e41d9a2.svg";
export { ForwardRef as ReactComponent };